export class Classifications {
    'dataClassesDetails';
    'environmentDetails';
    'appsDetails';
    'sensitivityAnnotationsDetails';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClassesDetails",
            "baseName": "dataClassesDetails",
            "type": "DataClassesDetails",
            "format": ""
        },
        {
            "name": "environmentDetails",
            "baseName": "environmentDetails",
            "type": "EnvironmentDetails",
            "format": ""
        },
        {
            "name": "appsDetails",
            "baseName": "appsDetails",
            "type": "AppsDetails",
            "format": ""
        },
        {
            "name": "sensitivityAnnotationsDetails",
            "baseName": "sensitivityAnnotationsDetails",
            "type": "SensitivityAnnotationsDetails",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Classifications.attributeTypeMap;
    }
    constructor() {
    }
}
